import React, { Dispatch, MouseEvent, SetStateAction, useCallback } from 'react';
import { HStack, Flex, Button, Box } from '@cad-arc';
export type FormatType = 'DD' | 'DMS' | 'DDM';

export function MaritimeFormatsButtonsSection({
    formattedValue,
    activeFormat,
    setActiveFormat,
}: {
    formattedValue?: string;
    activeFormat: FormatType;
    setActiveFormat: Dispatch<SetStateAction<FormatType>>;
}) {
    const handleActiveFormatChange = useCallback(
        (e: MouseEvent<HTMLButtonElement>, activeFormat: FormatType) => {
            e.stopPropagation();
            setActiveFormat(activeFormat);
        },
        [setActiveFormat]
    );

    return (
        <Flex
            data-testid="maritime-buttons-section"
            alignItems="center"
            justifyItems="center"
            justifyContent="space-between"
            gap={2}
            m="8px auto"
        >
            {formattedValue && <Box>{formattedValue}</Box>}
            <HStack>
                <Button
                    variant="outline"
                    isActive={activeFormat === 'DD'}
                    onClick={(e) => handleActiveFormatChange(e, 'DD')}
                >
                    DD
                </Button>
                <Button
                    variant="outline"
                    isActive={activeFormat === 'DMS'}
                    onClick={(e) => handleActiveFormatChange(e, 'DMS')}
                >
                    DMS
                </Button>
                <Button
                    variant="outline"
                    isActive={activeFormat === 'DDM'}
                    onClick={(e) => handleActiveFormatChange(e, 'DDM')}
                >
                    DDM
                </Button>
            </HStack>
        </Flex>
    );
}
